import { Helmet } from "react-helmet";
import RandingStyle11 from "../../randing/RandingStyle11";
import RandingStyle12 from "../../randing/RandingStyle12";

function Randing169({ urlCode, urlCodeSettingId }) {
  return (
    <>
      <Helmet>
        <title>검뉴치 교정 할인 이벤트</title>
      </Helmet>
      <RandingStyle12
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        img1Path={`${process.env.REACT_APP_CDN_BASE}/images/169/1.png`}
        img2Path={`${process.env.REACT_APP_CDN_BASE}/images/169/2.gif`}
        img3Path={`${process.env.REACT_APP_CDN_BASE}/images/169/3.png`}
        formFieldColor="white"
        privacyMessage="개인정보 수집 및 이용에 관한 내용을 확인하고 동의함"
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton_small.png`}
        companyName="치아건강지키미"
        isCallInsideContactBox={false}
        isKakaoInsideContactBox={false}
        fixedDbImgPath={`${process.env.REACT_APP_CDN_BASE}/images/169/4.png`}
        fixedDbColor="rgba(255, 255, 255, 0.8)"
        isFixedCallIcon={false}
        isFixedKakaoIcon={false}
        articleOption={true}
        benefitInfo={false}
        redirectUrl="http://검단뉴욕치과.com/"
      />
    </>
  );
}

export default Randing169;
